// Tiny Meta Pixel wrapper. The base loader + initial PageView fire in
// public/index.html; this helper is only used for SPA route changes
// (PageView) and conversion events (Lead, Purchase). All calls are no-ops
// when the pixel hasn't loaded yet or the ID isn't configured, so unit
// tests + the preview env never throw.
const hasFbq = () => typeof window !== "undefined" && typeof window.fbq === "function";

export function trackPageView() {
  if (hasFbq()) window.fbq("track", "PageView");
}

export function trackLead(params) {
  if (hasFbq()) window.fbq("track", "Lead", params || {});
}

export function trackPurchase(params) {
  if (hasFbq()) window.fbq("track", "Purchase", params || { currency: "ZAR" });
}

export function trackCompleteRegistration(role) {
  if (hasFbq()) window.fbq("track", "CompleteRegistration", { content_name: role || "unknown", status: true });
}
